export default "__VITE_ASSET__DM3v5v2u__"